<template>
  <div>
    <ts-dialog title="Share this page by link" :visible.sync="visible" width="550px" center :show-close="false">
      <p class="label">With this link, anyone can fill the brief and submit it. An easy way to share infos with your client! </p>
      <div class="flex items-center justify-center mb-2">
        <div class="row">
          <p class="font-semibold" v-text="url"></p>
        </div>
        <div class="actions">
          <ts-button size="small" circle @click="copy">
            <ts-icon icon="link" size="x-small" title="Copy" color="#6d7587" />
          </ts-button>
        </div>
      </div>
        <ts-form-item label="Add a specific comment to the page (optional) : " :validation="$v.form.description">
          <ts-input type="textarea" :rows="6" placeholder="" v-model.lazy="$v.form.description.$model"></ts-input>
        </ts-form-item>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" title="Close" @click="handleCloseButton">Close</ts-button>
        </div>
        <div class="font-semibold">
          <ts-button class="font-semibold" title="Share" filled type="primary" :loading="isSharing" @click="handleShareButton">Share</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button :loading="loading" type="primary" title="Share" size="small" filled @click="handleOpenDialogButtonClick">
      Share this brief
    </ts-button>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import projectViewHelpers from '@/mixins/projectViewHelpers';
import { config, appId } from '@/api/workflow';

export default {
  mixins: [projectViewHelpers],
  name: 'ShareBrief',
  data() {
    return {
      loading: false,
      visible: false,
      isSharing: false,
      appUrl: null,
      form: {
        description: ''
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      project: state => state.currentProject.value
    }),
    sharing() {
      return this.project?.sharings.find(s => s.resource === 'brief');
    },
    url() {
      return `${this.appUrl}/projects/sharings/${this.sharing?.token}/brief`;
    }
  },
  validations: {
    form: {
      description: {}
    }
  },
  methods: {
    ...mapActions('workflow', ['shareProjectResource']),
    async copy() {
      try {
        await this.$copyText(this.url);
        this.showInfo('Link copied to clipboard');
      } catch (err) {
        console.error('Error when copying brief shraing', err);
        this.showError('Error when copying brief share link');
      }
    },
    async handleShareButton() {
      this.isSharing = true;
      this.shareFinalassets().then(() => {
        this.isSharing = false;
        this.copy()
      }).catch(err => this.isSharing = false);
    },
    handleCloseButton() {
      this.visible = false;
    },
    handleOpenDialogButtonClick() {
      this.loading = true;
      this.grabSharingLink().then(() => {
        this.loading = false;
        this.visible = true;
        this.form.description = this.sharing.description;
      });
    },
    async grabSharingLink() {
      if (!this.sharing) {
        this.shareFinalassets();
      }
    },
    async shareFinalassets() {
      return await this.shareProjectResource({
        projectId: this.project.id,
        description: this.form.description,
        resource: 'brief'
      });
    },
    resetForm() {
      this.form = {
        description: ''
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
        this.resetForm();
      }
    }
  },
  mounted() {
    this.appUrl = config('auth.appUrl');
  }
};
</script>

<style lang="scss" scoped>
.label{
  font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
    word-break: break-word;
    margin-bottom: .5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;
  margin-right: 1rem;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>